import { APIPermissions } from 'labxchange-client/models/APIPermissions';

/** Login model definitions */

export interface LoginStatusModel {
    loginErrorMessage: null | string;
    /** The full name of the user */
    name: string;
    /** The OAuth2 token used to call the LabXchange API */
    token: string;
    /** The username of the logged in user */
    username: string;
    /** The avatar URL of the logged in user */
    avatarUrl: string;
    /** The general permissions for the user */
    permissions?: APIPermissions;
    /** The onboarding status for the user */
    onboardingStatus: null | string;
    /** The cookie acceptance status */
    acceptedCookieAgreement: boolean | undefined;
}

export const notLoggedInStatus: Readonly<LoginStatusModel> = {
    loginErrorMessage: null,
    onboardingStatus: null,
    name: '',
    token: '',
    username: '',
    avatarUrl: '',
    acceptedCookieAgreement: undefined,
};
